import React from "react";
import Markdown from "react-markdown";
import CodeBox from "./CodeBox";
import "../QuizApp.css";

type Props = {
  topText: string[];
  bottomText: string[] | undefined;
  source: string[] | undefined;
};

const Explanation = ({ topText, bottomText, source }: Props) => {
  const topTextExplanation = topText ? topText.join("\n") : null;
  const bottomTextExplanation = bottomText ? bottomText.join("\n") : null;
  const explanationCode = source ? source.join("\n") : null;

  return (
    <>
      <Markdown className="markdown">{topTextExplanation}</Markdown>
      {explanationCode && <CodeBox code={explanationCode} />}
      {bottomTextExplanation && (
        <Markdown className="markdown">{bottomTextExplanation}</Markdown>
      )}
    </>
  );
};

export default Explanation;
